import * as React from 'react'

export const ActivityTag = ({ nameOfActivity, activityIconSrc, className }: { nameOfActivity: string, activityIconSrc: string, className?: string }) => {
    return (
        <div className={`rounded-xl inline-flex px-3 py-1 justify-start bg-black bg-opacity-30 ${className}`}>
            <img src={activityIconSrc} className="h-4 pr-2.5" alt="" />
            <p className="text-xs font-b text-white">{nameOfActivity}</p>
        </div>
    )
}